import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Doughnut from "components/ChartCircle";
import { Button } from "react-bootstrap";
import axios from "axios";
import Loader from "./Loader";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { checkUser } from "common/FunctionUtils";
import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";

const OuterCalculator = () => {
  const { t } = useTranslation();
  const { register, reset } = useForm();
  const location = useLocation();
  let isUser = checkUser();

  const [salaryAfterTax, setSalaryAfterTax] = useState(0);
  const [amountValue, setAmountValue] = useState(0);
  const [advice, setAdvice] = useState();
  const [showCalc, setShowCalc] = useState(false);
  const [amount, setAmount] = useState(0);
  const [salaryTax, setSalaryTax] = useState(0);
  const [loading, setLoading] = useState(false);

  const { user } = useSelector((state) => state.auth);

  const handleSalaryChange = (value) => {
    if (value !== 0) {
      setSalaryTax(value);
      setAmount(0);
    }
    setSalaryAfterTax(value);
    setAmountValue(0);
  };

  const handleAmountChange = (value) => {
    if (value !== 0) {
      setAmount(value);
      setSalaryTax(0);
    }
    setAmountValue(value);
    setSalaryAfterTax(0);
  };

  const handleCalculator = async () => {
    try {
      if (Number(amount) !== 0 || Number(salaryTax) !== 0) {
        setLoading(true);
        const id = user?.userId ? user?.userId : 0;
        const res = await axios.get(
          `/calculator/calculate/${amount ? amount : 0}/${
            salaryTax ? salaryTax : 0
          }?Id=${id}`
        );
        if (res.data.statusCode === 200 && res.data.response.amount !== 0) {
          setShowCalc(true);
        } else if (res.data.response.amount === 0) {
          setShowCalc(false);
        }
        setAdvice(res.data.response);
        reset({
          amountInputValue: Number(
            res.data.response.amount?.toFixed()
          ).toLocaleString(LOCALES.EN_US), 
          salaryInputValue: Number(
            res.data.response.net?.toFixed()
          ).toLocaleString(LOCALES.EN_US), 
        });
        setLoading(false);
      } else {
        setAdvice();
        reset({
          amountInputValue: "",
          salaryInputValue: "",
        });
        setShowCalc(false);
        toast.error(t("Please enter an amount"));
      }
    } catch (err) {
      if (err?.response?.data) {
        toast.error(t(err?.response?.data?.message));
      } else {
        toast.error(t(err?.message));
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader />}
      {/* Calculate Salary Section  */}

      <section className="calculate-salary calc_new new_add pb-5">
        <div className="container calc">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="calculator">
                {location.pathname !==
                  "/freelance-consultant-salary-invoice-without-a-company" &&
                  location.pathname !==
                    "/frilans-konsult-lon-fakturera-utan-foretag" &&
                  location.pathname !== "/invoice-without-company-or-business" &&
                  location.pathname !==
                    "/fakturera-utan-foretag-eller-bolag" && (
                    <h2 className="text-center text-uppercase pb-0">
                      {location.pathname === "/business"
                        ? t("CALCULATE YOUR FREELANCERS SALARY")
                        : t("CALCULATE YOUR SALARY")}
                    </h2>
                  )}

                <p className="text-center font-weight-bold pb-2">
                  {t("Calculator")}
                </p>

                <div className="main-group ">
                  <div className="d-flex align-items-center new_dv_add">
                    <div className="form">
                      <form>
                        <div className="range_picker">
                          <div className="form-group place">
                            <label htmlFor="exampleFormControlInput1">
                              {t("AMOUNT TO INVOICE")}
                            </label>
                            <input
                              type="text"
                              className="form-control home_calculate"
                              id="invoice"
                              placeholder={t(
                                "Enter your invoicing amount here."
                              )}
                              onFocus={(e) =>
                                e.target.addEventListener(
                                  "wheel",
                                  function (e) {
                                    e.preventDefault();
                                  },
                                  { passive: false }
                                )
                              }
                              onKeyDown={(e) => {
                                // Allow only numbers, decimal point, and specific control keys
                                if (
                                  !/[\d.]/.test(e.key) &&
                                  ![
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Tab",
                                    "Delete",
                                  ].includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              {...register("amountInputValue", {
                                onChange: (e) => {
                                  handleAmountChange(e.target.value);
                                },
                              })}
                            />

                            <div className="sek">
                              <span>SEK</span>
                            </div>
                          </div>
                        </div>

                        <div className="range_picker">
                          <div className="form-group place">
                            <label htmlFor="exampleFormControlInput1">
                              {t("SALARY AFTER TAX")}
                            </label>
                            <input
                              type="text"
                              className="form-control home_calculate"
                              id="salaryAfterTax"
                              onKeyDown={(e) => {
                                // Allow only numbers, decimal point, and specific control keys
                                if (
                                  !/[\d.]/.test(e.key) &&
                                  ![
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Tab",
                                    "Delete",
                                  ].includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder={t(
                                "Or enter your salary after all taxes and fees."
                              )}
                              {...register("salaryInputValue", {
                                onChange: (e) => {
                                  handleSalaryChange(e.target.value);
                                },
                              })}
                            />
                            <div className="sek">
                              <span>SEK</span>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="text-center mb-3 mobile-view">
                      <Button
                        variant=""
                        className="mr-3 mt-4 bottom_create_btn"
                        onClick={handleCalculator}
                      >
                        {t("Calculate")}
                      </Button>
                    </div>

                    <div className="w-100">
                      <div
                        className={
                          advice?.amount
                            ? "calculate-group new_add"
                            : "calculate-group ml-auto"
                        }
                      >
                        <div className="second-group">
                          <div className="calculate-graph d-flex justify-content-center align-items-center">
                            {/* {advice?.amount && ( */}
                            <div id="doughnut-chart" className="e-chartssd">
                              <Doughnut
                                chartData={[
                                  {
                                    label: `${t("Salary")}`,
                                    value: advice?.toPay
                                      ? advice?.toPay
                                      : 10439.548,
                                  },
                                  {
                                    label: `${t("Social Fees")}`,
                                    value: advice?.socialFee
                                      ? advice?.socialFee
                                      : 4686.36,
                                  },
                                  {
                                    label: `${t("Gross Fee")}`,
                                    value: advice?.gross
                                      ? advice?.gross
                                      : 14913.64,
                                  },
                                  {
                                    label: `${t("Income Tax")}`,
                                    value: advice?.tax ? advice?.tax : 4474.092,
                                  },
                                ]}
                                dataColors='["#5d47b6", "#9400d3","#9370db", "#8a2be2"]'
                              />
                            </div>
                            {/* )} */}
                          </div>
                        </div>

                        <div className="text">
                          <p>
                            {t(
                              "Calculators provide an estimate and may include deviation factors"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {advice && showCalc && (
                    <div className="loan">
                      <div className="loan-group">
                        <p>{t("Invoice amount inc. VAT")}</p>
                        <p className="new_pr">
                          SEK {advice?.amountIncludingVat?.toFixed()}
                        </p>
                      </div>

                      <div className="loan-group">
                        <p>{t("VAT")}</p>
                        <p className="new_pr">SEK {advice.vat?.toFixed()} </p>
                      </div>

                      <div className="loan-group">
                        <p>{t("Invoice amount ex. VAT")}</p>
                        <p className="new_pr">SEK {advice.amount?.toFixed()}</p>
                      </div>

                      <div className="loan-group">
                        <p>
                          <b style={{ color: "#201e1e" }}>*</b>
                          {t("Invozio Fee")}
                        </p>
                        <p className="new_pr">SEK {advice.fee?.toFixed()}</p>
                      </div>

                      <div className="loan-group">
                        <p>
                          <b style={{ color: "#201e1e" }}>*</b>
                          {t("Social Fees")} {advice?.socialFeeRateDeduction}%
                        </p>
                        <p className="new_pr">
                          SEK {advice.socialFee?.toFixed()}
                        </p>
                      </div>

                      <div className="loan-group">
                        <p> {t("Gross salary incl. holiday pay")}</p>
                        <p className="new_pr">SEK {advice.gross?.toFixed()}</p>
                      </div>

                      <div className="loan-group">
                        <p>
                          {" "}
                          {t("Income Tax")}{" "}
                          {isUser ? `${advice?.taxRateDeduction}%` : "30%"}
                        </p>
                        <p className="new_pr">SEK {advice.tax?.toFixed()}</p>
                      </div>

                      <div className="loan-group">
                        <p> {t("Net salary incl. holiday pay")} </p>
                        <p> SEK {advice.net?.toFixed()}</p>
                      </div>

                      <div
                        className={
                          location.pathname ===
                            "/frilans-konsult-lon-fakturera-utan-foretag" ||
                          location.pathname ===
                            "/freelance-consultant-salary-invoice-without-a-company"
                            ? "loan-group mt-2"
                            : "loan-group justify-content-center"
                        }
                      >
                        <span style={{ color: "rgb(164 117 117)" }}>
                          *
                          {t(
                            "A minimum fee of 190 SEK applies if 1.9% of the invoice amount is lower."
                          )}
                        </span>
                      </div>
                      <div
                        className={
                          location.pathname ===
                            "/frilans-konsult-lon-fakturera-utan-foretag" ||
                          location.pathname ===
                            "/freelance-consultant-salary-invoice-without-a-company"
                            ? "loan-group mt-2"
                            : "loan-group"
                        }
                      >
                        <span style={{ color: "rgb(164 117 117)" }}>
                          *
                          {t(
                            "If you are 66 years or older, our platform automatically calculates your social security contributions at 10.21%"
                          )}
                        </span>
                      </div>

                      <Button
                        className="mb-2 p-0 mt-2"
                        onClick={() => setShowCalc(false)}
                        variant="link"
                        size="sm"
                      >
                        {t("Hide how we calculated")} -
                      </Button>
                    </div>
                  )}

                  {advice && !showCalc && advice.amount !== 0 && (
                    <Button
                      className="mb-2 p-0 text-white"
                      onClick={() => setShowCalc(true)}
                      variant="link"
                      size="sm"
                    >
                      {t("See how we calculated")} +
                    </Button>
                  )}
                </div>
              </div>

              <div className="text-center mb-3 mobile-none">
                <Button
                  variant=""
                  className="mr-3 mt-4 bottom_create_btn"
                  onClick={handleCalculator}
                >
                  {t("Calculate")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OuterCalculator;
